import { acceptHMRUpdate, defineStore } from 'pinia'
import { LocationsApi } from '~/services/apiClientGps'
import type { SavedLocation } from '~/services/apiClientGps'

export const useLocationsStore = defineStore('locations', () => {
  // State
  const locations = ref<SavedLocation[]>([])
  const loading = ref(false)
  const error = ref<string | null>(null)

  // Getters
  const locationOptions = computed(() => {
    return locations.value.map((location) => ({
      value: location.id.toString(),
      label: location.name,
    }))
  })

  // Actions
  async function loadLocations() {
    if (loading.value || locations.value.length > 0) return

    try {
      loading.value = true
      error.value = null

      const api = new LocationsApi()
      const response = await api.getAllLocationsLocationsGet()
      locations.value = response.data.filter((loc) => !loc.deleted)
    } catch (err: any) {
      console.error('Error loading locations:', err)
      error.value =
        err.response?.data?.detail || err.message || 'Failed to load locations'
    } finally {
      loading.value = false
    }
  }

  return {
    locations,
    loading,
    error,
    locationOptions,
    loadLocations,
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useLocationsStore, import.meta.hot))
}
